import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Building2 } from "lucide-react";

export interface EmpresaOption {
  empresa_id: number;
  nome: string;
  modelo_acesso?: string | null;
}

interface SelectEmpresaDialogProps {
  open: boolean;
  empresas: EmpresaOption[];
  onSelect: (empresaId: number) => void;
}

export function SelectEmpresaDialog({ open, empresas, onSelect }: SelectEmpresaDialogProps) {
  return (
    <Dialog open={open}>
      <DialogContent
        className="sm:max-w-md"
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Selecionar empresa</DialogTitle>
          <DialogDescription>
            Você tem acesso a mais de uma empresa. Escolha em qual deseja
            entrar agora.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-2 py-2">
          {empresas.map((emp) => (
            <Button
              key={emp.empresa_id}
              variant="outline"
              className="justify-start h-auto py-3"
              onClick={() => onSelect(emp.empresa_id)}
            >
              <Building2 className="h-4 w-4 mr-2 shrink-0" />
              <div className="flex flex-col items-start text-left">
                <span className="font-medium">{emp.nome}</span>
                {emp.modelo_acesso && (
                  <span className="text-xs text-muted-foreground capitalize">
                    {emp.modelo_acesso}
                  </span>
                )}
              </div>
            </Button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
